import React from 'react';
import {
  RelatedCharacterItem,
  RelatedOrganizationItem,
  RelatedLocationItem,
  RelatedArticleItem,
} from './';

export function RelatedArticlesDisplay({ articles }) {
  const RenderedArticleInterface = {
    character: RelatedCharacterItem,
    organization: RelatedOrganizationItem,
    location: RelatedLocationItem,
    article: RelatedArticleItem,
  };
  return (
    <div className="chronos-related-articles-display">
      {articles && articles.length > 0 && (
        <div className="chronos-related-articles-wrapper">
          {articles.map((a) => {
            const ChosenArticle =
              RenderedArticleInterface[a.type] || RelatedArticleItem;
            return <ChosenArticle article={a} key={a.waID} />;
          })}
        </div>
      )}
    </div>
  );
}
